import React from 'react'
import { ThemeSection } from './ThemeSection'
import { TrendingSection } from './TrendingSection'
import { LetterIndexSection } from './LetterIndexSection'
import { HeroSection } from './HeroSection'
import type { Glossary } from '@/types/glossary'
import { VStack } from '@chakra-ui/react'

export const Page = ({
  allGlossary,
  TrendingGlossary,
}: {
  allGlossary: Glossary[]
  TrendingGlossary: Glossary[]
}) => {
  return (
    <VStack>
      <HeroSection paddingTop={[28, null, null, 40]} />
      <TrendingSection
        marginTop={[32, null, 40, null]}
        data={TrendingGlossary}
      />
      <LetterIndexSection data={allGlossary} paddingBottom={[60]} />
    </VStack>
  )
}
